import type { MessageDispatch } from '@/lib/types'
import type { MsgType } from '@/lib/order-storage'

export interface MessageStateSource {
  messageStates?: MessageDispatch[]
}

const KIND_BY_LEGACY: Record<MsgType, MessageDispatch['kind']> = {
  firstMsg: 'first_message',
  confirmMsg: 'confirmation',
  courierMsg: 'courier',
}

export function messageStateFor(source: MessageStateSource, kind: MsgType): MessageDispatch | undefined {
  return source.messageStates?.find((state) => state.kind === KIND_BY_LEGACY[kind])
}
